module.exports = __webpack_public_path__ + "img/e1.248c0ca3.png";